<template>
    <div>
        <DRow>
            <DCol>
                <DTabs class="mb-3 flex-wrap">
                    <DTabItem
                        v-if="userPermissions.includes('settings.lov_payment_terms')"
                        id="lov-layout-payment-terms"
                        :route-url="$route('settings.payment-terms.index')"
                        :active="['settings.payment-terms.index'].includes($route().current())"
                        :label="__('settings.payment_terms.form.payment_term')"
                    />
                    <DTabItem
                        v-if="userPermissions.includes('settings.lov_countries')"
                        id="lov-layout-countries"
                        :route-url="$route('settings.countries.index')"
                        :active="['settings.countries.index'].includes($route().current())"
                        :label="__('settings.countries.title')"
                    />
                    <DTabItem
                        v-if="userPermissions.includes('settings.lov_legal_forms')"
                        id="lov-layout-lov-legal-forms"
                        :route-url="$route('settings.legal-forms.index')"
                        :active="['settings.legal-forms.index'].includes($route().current())"
                        :label="__('settings.legal_forms.name')"
                    />
                    <DTabItem
                        v-if="userPermissions.includes('settings.lov_incidents')"
                        id="lov-layout-incident-values"
                        :route-url="$route('settings.incident-values.index')"
                        :active="['settings.incident-values.index'].includes($route().current())"
                        :label="__('settings.lov_incidents.name')"
                    />
                    <DTabItem
                        v-if="userPermissions.includes('settings.lov_termination_reasons')"
                        id="lov-layout-termination-reasons"
                        :route-url="$route('settings.termination-reasons.index')"
                        :active="['settings.termination-reasons.index'].includes($route().current())"
                        :label="__('settings.lov_termination_reasons.name')"
                    />
                    <DTabItem
                        v-if="userPermissions.includes('settings.lov_billing_cycles')"
                        id="lov-layout-billing-cycles"
                        :route-url="$route('settings.billing-cycles.index')"
                        :active="['settings.billing-cycles.index'].includes($route().current())"
                        :label="__('settings.lov_billing_cycles.name')"
                    />
                    <DTabItem
                        v-if="userPermissions.includes('settings.original_brands')"
                        id="lov-layout-original-brands"
                        :route-url="$route('settings.original-brands.index')"
                        :active="['settings.original-brands.index'].includes($route().current())"
                        :label="__('settings.lov_original_brands.name')"
                    />
                    <DTabItem
                        v-if="userPermissions.includes('settings.electronic_invoice_operators')"
                        id="lov-layout-electronic-invoice-operators"
                        :route-url="$route('settings.electronic-invoice-operators.index')"
                        :active="['settings.electronic-invoice-operators.index'].includes($route().current())"
                        :label="__('settings.electronic_invoice_operators.name')"
                    />
                </DTabs>
            </DCol>
        </DRow>

        <slot />
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

const userPermissions = computed(() => usePage().props.auth.permissions)
</script>
